import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { IPost } from '../../types';

interface IProps {
	post: IPost;
}

const SuccessStory = ({ post }: IProps) => {
	const cardClasses = [
		'pfa-card-success-story',
		post.post_type ? `pfa-card-success-story--${post.post_type}` : '',
	]
		.filter(Boolean)
		.join(' ');

	const displayTitle = post.success_story_tagline || post.post_title;

	return (
		<a href={post.permalink} target="_self" rel="noreferrer" className={cardClasses}>
			<figure className="pfa-card-success-story__figure">
				{post.success_story_logo && (
					<div
						className="pfa-card-success-story__logo"
						dangerouslySetInnerHTML={{
							__html: post.success_story_logo,
						}}
					></div>
				)}
				{!!post.featured_image && (
					<span
						className="pfa-card-success-story__img"
						dangerouslySetInnerHTML={{ __html: post.featured_image }}
					/>
				)}
			</figure>
			<div className="pfa-card-success-story__content cms">
				{post.industry?.name && (
					<p
						className="pfa-card-success-story__tag"
						dangerouslySetInnerHTML={{
							__html: sanitizeHtml(post.industry.name),
						}}
					/>
				)}
				{displayTitle && (
					<h3
						className="pfa-card-success-story__title"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(displayTitle) }}
					/>
				)}
			</div>
		</a>
	);
};

SuccessStory.displayName = 'SuccessStory';

export default SuccessStory;
